import React, { ReactElement } from "react";

import { useComponentTexts } from "Store/texts/hooks";

interface Props {
  value?: boolean;
}

export const YesOrNo = ({ value }: Props): ReactElement<Props> => {
  const [{ boolean }, lang] = useComponentTexts();
  return <span>{value ? `${boolean.yes[lang]}` : `${boolean.no[lang]}`}</span>;
};
